/* External */
import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';

/* Utils */
import { noOp } from '../../utils/functions';
import withInteractiveFocusable from '../../hocs/withInteractiveFocusable.hoc';

/* Styles */
import './KeyButton.scss';

function KeyButton({
  character,
  isVariation,
  className,
  focused,
  onMouseDown,
  onMouseEnter,
  onMouseLeave,
  onBecameFocused,
  onBecameBlurred,
}) {
  const handleMouseEnter = useCallback((e) => {
    onBecameFocused(e);
    onMouseEnter(e);
  }, [onBecameFocused, onMouseEnter]);

  const handleMouseLeave = useCallback((e) => {
    onBecameBlurred(e);
    onMouseLeave(e);
  }, [onBecameBlurred, onMouseLeave]);

  return (
    <button
      type="button"
      className={`dtv-html5-c-key-button-profile ${
        focused ? 'dtv-html5-c-key-button-profile--focused' : ''
      } ${className} ${
        isVariation ? 'dtv-html5-c-key-button-profile--variation' : ''
      }`}
      onMouseDown={onMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {character}
    </button>
  );
}

KeyButton.defaultProps = {
  character: '',
  className: '',
  isVariation: false,
  onMouseDown: noOp,
  onMouseEnter: noOp,
  onMouseLeave: noOp,
  onBecameFocused: noOp,
  onBecameBlurred: noOp,
};

KeyButton.propTypes = {
  character: PropTypes.string,
  className: PropTypes.string,
  isVariation: PropTypes.bool,
  focused: PropTypes.bool.isRequired,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onBecameFocused: PropTypes.func,
  onBecameBlurred: PropTypes.func,
};

export default memo(withInteractiveFocusable()(memo(KeyButton)));
